import { CSSProperties, ReactNode } from 'react';
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
} from 'recharts';

import {
  ChartContainerWrapper,
  ChartFootnote,
  EmptyRankingState,
} from './styles';
import { formatNumber, formatCompactNumber } from './utils';

interface IRankingBarChartProps {
  title: string;
  data: any[];
  dataKeyY: string;
  yAxisWidth: number;
  barColor: string;
  footnote: ReactNode;
  emptyMessage: string;
  tickFormatterY?: (value: any) => string;
  tooltipContentStyle?: CSSProperties;
}

export const RankingBarChart = ({
  title,
  data,
  dataKeyY,
  yAxisWidth,
  barColor,
  footnote,
  emptyMessage,
  tickFormatterY,
  tooltipContentStyle,
}: IRankingBarChartProps) => (
  <ChartContainerWrapper style={{ padding: '16px 8px', margin: 0 }}>
    <h3 style={{ paddingLeft: '8px' }}>{title}</h3>
    {data.length === 0 ? (
      <EmptyRankingState>{emptyMessage}</EmptyRankingState>
    ) : (
      <>
        <ResponsiveContainer debounce={100} width="100%" height={550}>
          <BarChart
            layout="vertical"
            data={data}
            margin={{ top: 10, right: 20, left: 10, bottom: 0 }}
          >
            <CartesianGrid
              strokeDasharray="3 3"
              horizontal={true}
              vertical={true}
              stroke="#e2e8f0"
            />
            <XAxis
              type="number"
              axisLine={false}
              tickLine={false}
              tick={{ fill: '#64748b', fontSize: 11, fontWeight: 500 }}
              tickFormatter={val => formatCompactNumber(val)}
            />
            <YAxis
              dataKey={dataKeyY}
              type="category"
              width={yAxisWidth}
              axisLine={false}
              tickLine={false}
              tick={{ fill: '#64748b', fontSize: 13, fontWeight: 500 }}
              tickFormatter={tickFormatterY}
            />
            <Tooltip
              cursor={{ fill: '#f1f5f9' }}
              contentStyle={{
                borderRadius: '12px',
                border: 'none',
                boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                maxWidth: '220px',
                whiteSpace: 'normal',
                ...tooltipContentStyle,
              }}
              formatter={value => [
                `${formatNumber(Number(value))} L`,
                'Volume Total',
              ]}
            />
            <Bar
              dataKey="VOLUME_TOTAL"
              fill={barColor}
              radius={[0, 4, 4, 0]}
              barSize={24}
            />
          </BarChart>
        </ResponsiveContainer>
        <ChartFootnote>{footnote}</ChartFootnote>
      </>
    )}
  </ChartContainerWrapper>
);

export default RankingBarChart;
